<template>
    <v-card>
        <v-container>
            <v-layout align-center column>
                <v-row>
                    <v-col>
                        <v-date-picker :disabled="loading" v-model="picker"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn :color="success ? 'success':'primary'" :disabled="!picker" :loading="loading" @click="mainButtonClicked"
                               width="100%">
                            <span v-if="!success">Générer le rapport</span>
                            <span v-else>Télécharger le rapport</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-layout>
        </v-container>

        <v-snackbar :top="true" color="error" v-model="error">
            Une erreur est survenue. Veuillez réessayer, ou contacter l'équipe de support de Yodatech
            <v-btn @click="error = false" dark text>Fermer</v-btn>
        </v-snackbar>
        <v-snackbar :bottom="true" :timeout="5000" color="error" v-model="downloadError">
            Une erreur est survenue. Veuillez réessayer, ou contacter l'équipe de support de Yodatech
            <v-btn @click="downloadError = false" dark text>Fermer</v-btn>
        </v-snackbar>

    </v-card>
</template>

<script>
	export default {
		name: "ManualReportProcessingCard",
		data() {
			return {
				picker: null,
				loading: false,
				success: false,
                lastReportId: -1,
				error: false,
				downloadError: false
			}
		},
		watch: {
			picker(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.success = false;
				}
			}
		},
		methods: {
			mainButtonClicked() {
				if (!this.success) {
					this.triggerProcessing(this.picker);
				} else {
					this.downloadFile(this.lastReportId, this.picker);
				}
			},
			triggerProcessing(date) {
				this.loading = true;
				this.error = false;
				this.$http.post(this.$config.apiUrl + "/reports/date/" + date + "/forceComputing")
					.then((r) => {
						this.$emit("success", date, r.data);
						this.lastReportId = r.data.id;
						this.success = true;
					})
					.catch((e) => this.error = true)
					.then(() => this.loading = false);

			},
			downloadFile(id, date) {
				this.loading = true;
				this.downloadError = false;
				this.$http({
					url: this.$config.apiUrl + "/reports/id/" + id,
					method: 'GET',
					headers: {'Accept': 'text/csv'},
					responseType: 'blob', // important
				})
					.then((response) => {
						// Downloading the file
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'report-' + date + '.csv');
						document.body.appendChild(link);
						link.click();
					})
					.catch(e => this.downloadError = true)
					.finally(() => this.loading = false);
			}
		}
	}
</script>

<style scoped>

</style>
